import { render, staticRenderFns } from "./FoundGames.vue?vue&type=template&id=59e3c5c2&scoped=true"
import script from "./FoundGames.vue?vue&type=script&lang=js"
export * from "./FoundGames.vue?vue&type=script&lang=js"
import style0 from "./FoundGames.vue?vue&type=style&index=0&id=59e3c5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e3c5c2",
  null
  
)

export default component.exports